import React from "react"
import { FormSectionElements } from "../../entities/formTemplateDataType";

interface Props {
    field: FormSectionElements;
    isEng: boolean;
    id?: string;
}

export class LiveValidationErrMsg extends React.Component<Props> {

    constructor(props: Props) {
        super(props);

    }

    generateHtmlString = () => {
        let html = [];
        const field = this.props.field;
        const visible = field.Touched && !field.Valid;
        const message = field.IsEmpty ? (this.props.isEng ? field.EmptyErrorMessage : field.EmptyErrorMessageFRA)
            : (this.props.isEng ? field.ErrorMessage : field.ErrorMessageFRA);
        // const message = Utils.isNotNullOrEmpty(customizeMessage)?  customizeMessage: this.props.isEng? field.ENUTitle + " is invalid": field.FRATitle + " obligatoire";
        if (visible && message) {
            // const control = document.getElementById(field.LoadBindName);
            // if (control) control.setAttribute('aria-describedby', 'text-input-odometer-example-error-text');
            html.push(
                <div id="text-input-container" key={"text-input-container_" + this.props.field.Id} className="ontario-error-messaging">
                    <span className="ontario-error-messaging__icon">
                        <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#cd0000" />
                            <path d="M11 17h2v-2h-2v2zm0-4h2V7h-2v6z" fill="#fff" />
                            <use href="#ontario-icon-alert-error"></use>
                        </svg>
                    </span>
                    <span id={this.props.id || "text-input-odometer-example-error-text"} 
                        className="ontario-error-messaging__content"
                        style={{whiteSpace: 'pre-wrap'}}
                    >
                        {message}
                    </span>
                </div>
            );
            return html;

        }
        return null;
    }


    render() {
        return (
            this.generateHtmlString()
        )
    }
}
